// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"8f8bcccd","264":"dbaa861f","453":"f02c219e","480":"437099c4","638":"0d83778e","738":"4b0bc223","952":"fa80f715"}[chunkId] + ".chunk.js";
};